<ul>
  @for (advice of staticDataService.advice$ | async; track $index) {
    <li>
    <span class="advice">
      <span [class]="{ 'deleted' : advice.deleted }"
            class="advice-item">{{ advice.advice }}</span>

      @if (!advice.deleted) {
        <button (click)="toggleAdvice(advice)" mat-icon-button>
          <mat-icon class="negative">delete</mat-icon>
        </button>
      }

      @if (advice.deleted) {
        <button (click)="toggleAdvice(advice)"
                mat-icon-button>
          <mat-icon class="positive">check</mat-icon>
        </button>
      }
    </span>
    </li>
  }
</ul>
<div class="additional-advice-holder">
  <mat-form-field subscriptSizing="fixed">
    <mat-label>Ytterligare motivering</mat-label>
    <input [formControl]="customAdviceControl" matInput name="advice">
  </mat-form-field>
  <button (click)="addAdvice()" matButton="outlined">Lägg till
  </button>
</div>
